import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import dateFormat from "dateformat";
import { useNavigate } from "react-router-dom";

// Icons
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import orderReturnRequestStore from "../../stores/orderReturnRequestStore";
import { LoadingButton } from "@mui/lab";

const ReturnOrderRequestRow = ({ row }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const OrderReturnRequestStore = orderReturnRequestStore();

  const [statusBackgroundColor, setStatusBackgroundColor] = useState(null);
  const [statusColor, setStatusColor] = useState(null);

  const [isAcceptLoading, setIsAcceptLoading] = useState(false);

  useEffect(() => {
    if (row.status === "Request") {
      setStatusColor("#E4A11B");
      setStatusBackgroundColor("rgba(240, 172, 78,  0.200)");
    } else if (row.status === "Returning") {
      setStatusColor("#FFAEBC");
      setStatusBackgroundColor("rgba(255, 174, 188, 0.2)");
    } else if (row.status === "Returned") {
      setStatusColor("#DC4C64");
      setStatusBackgroundColor("rgba(220, 76, 100,  0.200)");
    } else if (row.status === "Cancel") {
      setStatusColor("#CDB37B");
      setStatusBackgroundColor("rgba(246, 237, 221,  0.200)");
    }
  }, []);

  const requestAccepted = async () => {
    setIsAcceptLoading(true);
    await OrderReturnRequestStore.updateReturningStatus({
      id: row.returnOrderRequestID,
      order_returning_status: true,
    });
    setIsAcceptLoading(false);
    setOpenDialog(false);
  };

  const [openDialog, setOpenDialog] = useState(false);

  const handleClickOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    if (!isAcceptLoading) {
      setOpenDialog(false);
    }
  };

  const [openCancelReturnDialog, setOpenCancelReturnDialog] = useState(false);
  const [isCancelLoading, setIsCancelLoading] = useState(false);

  const handleClickOpenCancelReturnDialog = () => {
    setOpenCancelReturnDialog(true);
  };

  const handleCloseCancelReturnDialog = () => {
    if (!isCancelLoading) {
      setOpenCancelReturnDialog(false);
    }
  };

  const cancelReturnOrderOnClick = async () => {
    setIsCancelLoading(true);
    await OrderReturnRequestStore.cancelReturnOrder({
      id: row.returnOrderRequestID,
    });
    setIsCancelLoading(false);
    setOpenCancelReturnDialog(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title">
          Accept Return Product?
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="inherit">
            Cancel
          </Button>
          <LoadingButton
            loading={isAcceptLoading}
            onClick={requestAccepted}
            autoFocus
            color="success"
          >
            Accept
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openCancelReturnDialog}
        onClose={handleCloseCancelReturnDialog}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title">
          Cancel Return Product?
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseCancelReturnDialog} color="inherit">
            Close
          </Button>
          <LoadingButton
            loading={isCancelLoading}
            onClick={cancelReturnOrderOnClick}
            autoFocus
            color="success"
          >
            Cancel Return Order
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            <KeyboardArrowDownIcon
              style={{
                transition: "all 0.5s ease",
                transform: !open ? "rotate(0deg)" : "rotate(-180deg)",
              }}
            />
          </IconButton>
        </TableCell>
        <TableCell>
          <p style={{ fontWeight: 600, fontSize: "13px" }}>#{row._id}</p>
        </TableCell>
        <TableCell component="th" scope="row">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p style={{ fontWeight: 600, fontSize: "15px" }}>{row.username}</p>
            <p
              style={{
                color: "hsl(240, 1%, 48%)",
                fontSize: "13px",
                fontWeight: 500,
              }}
            >
              {row.email}
            </p>
          </div>
        </TableCell>
        <TableCell>
          <div>
            <p style={{ fontWeight: 600, fontSize: "14px" }}>
              {dateFormat(new Date(row.orderReturnRequestDate), "mmm dd, yyyy")}
            </p>
            <p
              style={{
                color: "hsl(240, 1%, 48%)",
                fontSize: "13px",
                fontWeight: 500,
              }}
            >
              {dateFormat(new Date(row.orderReturnRequestDate), "hh:MM TT")}
            </p>
          </div>
        </TableCell>
        <TableCell>
          <div>
            <p style={{ fontWeight: 600, fontSize: "14px" }}>
              {row.orderReturnDate === "-"
                ? "-"
                : dateFormat(new Date(row.orderReturnDate), "mmm dd, yyyy")}
            </p>
            <p
              style={{
                color: "hsl(240, 1%, 48%)",
                fontSize: "13px",
                fontWeight: 500,
              }}
            >
              {row.orderReturnDate === "-"
                ? ""
                : dateFormat(new Date(row.orderReturnDate), "hh:MM TT")}
            </p>
          </div>
        </TableCell>
        <TableCell>
          <p style={{ fontWeight: 600, fontSize: "14px" }}>{row.totalQTY}</p>
        </TableCell>
        <TableCell>
          <p style={{ fontWeight: 600, fontSize: "14px" }}>₹{row.price}</p>
        </TableCell>
        <TableCell>
          <p
            style={{
              background: statusBackgroundColor && statusBackgroundColor,
              color: statusColor && statusColor,
              fontWeight: 700,
              fontSize: "14px",
              maxWidth: "fit-content",
              padding: "3px 7px",
              borderRadius: "7px",
            }}
          >
            {row.status}
          </p>
        </TableCell>
        <TableCell>
          <div style={{ display: "flex" }}>
            {row.status === "Request" && (
              <IconButton onClick={handleClickOpenDialog}>
                <CheckRoundedIcon />
              </IconButton>
            )}

            {row.status === "Returning" && (
              <IconButton onClick={handleClickOpenCancelReturnDialog}>
                <CloseRoundedIcon />
              </IconButton>
            )}

            <IconButton onClick={() => navigate(`/orders/${row._id}/details`)}>
              <VisibilityIcon />
            </IconButton>
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Order Return Product List
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <p style={{ fontWeight: 600, fontSize: "15px" }}>
                        Particular Order Product ID
                      </p>
                    </TableCell>
                    <TableCell>
                      <p style={{ fontWeight: 600, fontSize: "15px" }}>
                        Product Name
                      </p>
                    </TableCell>
                    <TableCell>
                      <p style={{ fontWeight: 600, fontSize: "15px" }}>Size</p>
                    </TableCell>
                    <TableCell>
                      <p style={{ fontWeight: 600, fontSize: "15px" }}>Color</p>
                    </TableCell>
                    <TableCell align="right">
                      <p style={{ fontWeight: 600, fontSize: "15px" }}>QTY</p>
                    </TableCell>
                    <TableCell align="right">
                      <p style={{ fontWeight: 600, fontSize: "15px" }}>
                        Total price (₹)
                      </p>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <p style={{ fontWeight: 500, fontSize: "13px" }}>
                        #{row.return_product._id}
                      </p>
                    </TableCell>
                    <TableCell>
                      <p style={{ fontWeight: 500, fontSize: "13px" }}>
                        {row.return_product.productName}
                      </p>
                    </TableCell>
                    <TableCell>
                      <p style={{ fontWeight: 500, fontSize: "13px" }}>
                        {row.return_product.size}
                      </p>
                    </TableCell>
                    <TableCell>
                      <p style={{ fontWeight: 500, fontSize: "13px" }}>
                        {row.return_product.color}
                      </p>
                    </TableCell>
                    <TableCell align="right">
                      <p style={{ fontWeight: 500, fontSize: "13px" }}>
                        {row.return_product.qty}
                      </p>
                    </TableCell>
                    <TableCell align="right">
                      <p style={{ fontWeight: 500, fontSize: "13px" }}>
                        {row.return_product.purchasePrice}
                      </p>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={6}>
                      Why return product note: {row.whyReturn}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

ReturnOrderRequestRow.propTypes = {
  row: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    orderReturnRequestDate: PropTypes.string.isRequired,
    orderReturnDate: PropTypes.string.isRequired,
    totalQTY: PropTypes.number.isRequired,
    return_product: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      productName: PropTypes.string.isRequired,
      qty: PropTypes.number.isRequired,
      purchasePrice: PropTypes.number.isRequired,
    }).isRequired,
    price: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
};

export default ReturnOrderRequestRow;
